(() => {
  const allowedFields = new Set([
    'source',
    'category',
    'product_id',
    'product_sku'
  ]);
  const sentOnce = new Set();

  function pageType() {
    const match = document.body.className.match(/(?:^|\s)template-([^\s]+)/);
    return match?.[1] || 'unknown';
  }

  function safeValue(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value !== 'string') return undefined;
    const normalized = value.trim().slice(0, 120);
    return normalized || undefined;
  }

  function safePayload(detail = {}) {
    const payload = {
      page_type: pageType(),
      path: window.location.pathname
    };
    Object.entries(detail).forEach(([key, value]) => {
      if (!allowedFields.has(key)) return;
      const safe = safeValue(value);
      if (safe !== undefined) payload[key] = safe;
    });
    return payload;
  }

  function publish(name, detail = {}, options = {}) {
    if (!/^[a-z0-9_]+$/.test(name)) return false;
    if (options.once && sentOnce.has(name)) return false;
    if (options.once) sentOnce.add(name);
    const eventName = `mishop:${name}`;
    const payload = safePayload(detail);

    try {
      const result = window.Shopify?.analytics?.publish?.(eventName, payload);
      result?.catch?.(() => {});
    } catch (error) {}

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...payload });
      }
    } catch (error) {}
    return true;
  }

  window.MishopConversion = Object.freeze({ publish });

  document.addEventListener('mishop:conversion', event => {
    const detail = event.detail || {};
    publish(String(detail.name || ''), detail.payload || {}, { once: detail.once === true });
  });

  document.addEventListener('focusin', event => {
    if (event.target.matches('.search__input, .search-block__input, input[type="search"]')) {
      publish('search_opened', { source: 'search_input' }, { once: true });
    }
  });

  document.addEventListener('submit', event => {
    if (event.target.matches('form[role="search"], form[action*="/search"]')) {
      publish('search_submitted', { source: 'search_form' });
    }
  });

  document.addEventListener('click', event => {
    const target = event.target.closest('[data-mishop-event], [data-mishop-category-view-all], [data-ai-whatsapp], [data-mishop-wholesale-whatsapp]');
    if (!target) return;

    if (target.dataset.mishopEvent) {
      publish(target.dataset.mishopEvent, { source: target.dataset.mishopSource || 'link' });
      return;
    }

    if (target.hasAttribute('data-mishop-category-view-all')) {
      publish('category_view_all_clicked', {
        source: 'homepage_category',
        category: target.dataset.mishopCategory || ''
      });
      return;
    }

    publish('ai_whatsapp_handoff_clicked', {
      source: target.hasAttribute('data-mishop-wholesale-whatsapp') ? 'product_wholesale' : 'ai_footer',
      product_id: target.closest('[data-mishop-wholesale-cta]')?.dataset.productId || '',
      product_sku: target.closest('[data-mishop-wholesale-cta]')?.dataset.productSku || ''
    });
  });
})();
